import React, { Fragment, useState, useEffect, useRef, useReducer } from 'react';

import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
// import { submitForm } from './search/redux/actions/actions';
import { useTranslation } from 'react-i18next';
import Select2Wrapper from '../Select2Wrapper';
import $ from 'jquery';
import Cookies from 'js-cookie';

import OmantelVisaHeader from './OmantelVisaHeader';

import '@fontsource/ibm-plex-sans/400.css';  // Regular weight
import '@fontsource/ibm-plex-sans/500.css';  // Medium weight
import '@fontsource/ibm-plex-sans/600.css';  // Semi-bold weight

import "./OmantelVisaStyle.css"
import { json } from 'react-router-dom';

const { config } = require('../api/api');


function OmantelVisaPage(){


      const [options, setCountries] = useState([]);
  const base_url = config.baseURL;
    const [vendorKey, setVendorkey] = useState(null);
    const [selectedDestinateCountry,setSelectedDestinateCountry]=useState("");
    const [selectedPassportCountry,setSelectedPassportCountry]=useState("");
    const [travelDate,setTravelDate]=useState(null);    
const [isHovered,setIsHovered]=useState(null);
const [lnstr,setlnstr]=useState("en");
const [loading ,setLoading]=useState(false);

const [userDetails,setUserDetails]=useState(null);
const [userInfoErr,setUserInfoErr]=useState(null);
const [userDataForVisa,setUserDataForVisa]=useState(null);
const [travelDateErr,setTravelDateErr]=useState("")

      const selectOpt1=useRef(null);

      const selectOpt2=useRef(null);
const { t,i18n } = useTranslation();
const switchLanguage = (lang) => {
  i18n.changeLanguage(lang);
};
useEffect(()=>{
  if(!userDetails){
    setUserInfoErr("Check Url query params");
  }
  else if((userDetails?.email===""||  userDetails?.email===null || userDetails?.email===undefined || userDetails?.email==="undefined")
    || (userDetails?.first_name ===""||userDetails?.first_name===null || userDetails?.first_name===undefined || userDetails?.first_name==="undefined")
   || (userDetails?.last_name ===""|| userDetails?.last_name ===null || userDetails?.last_name ===undefined  || userDetails?.last_name ==="undefined")
   || (userDetails?.locale ===""|| userDetails?.locale ===null || userDetails?.locale ===undefined || userDetails?.locale ==="undefined")){
    setUserInfoErr("Check Url query params");
 }
 else{
  setUserInfoErr("");
 }

},[userDetails])

      const handleSubmit=async(e)=>{
debugger
        e.preventDefault();
        debugger
        if(userInfoErr!==""){
          return;
        }
        if( selectedDestinateCountry==="" || selectedDestinateCountry===null || selectedDestinateCountry===undefined || selectedDestinateCountry==="Select"){
          $(selectOpt1.current)
          .next(".select2-container")
          .find(".select2-selection--single.omantel")
          .each(function() {
              $(this).addClass("error");  // Adds the "omantal" class alongside the existing classes
          });
          selectOpt1.current.focus();
        }
      if( selectedPassportCountry==="" || selectedPassportCountry===null || selectedPassportCountry===undefined || selectedPassportCountry==="Select"){
        $(selectOpt2.current)
        .next(".select2-container")
        .find(".select2-selection--single.omantel")
        .each(function() {
            $(this).addClass("error");  // Adds the "omantal" class alongside the existing classes
        });
        selectOpt2.current.focus();
      }
    
      if(travelDate==="" || travelDate===null || travelDate===undefined ){
        setTravelDateErr("select travel Date");
      }
try{
      if((selectedDestinateCountry!=="" && selectedDestinateCountry!==null && selectedDestinateCountry!==undefined&&selectedDestinateCountry!=="Select")
      &&( selectedPassportCountry!=="" && selectedPassportCountry!==null && selectedPassportCountry!==undefined&&selectedPassportCountry!=="Select")
    &&(travelDate!=="" && travelDate!==null && travelDate!==undefined)){
      setLoading(true);
      
        const response = await fetch(`${base_url}/create_traveller_omantel`,{
          method:"POST",
          headers:{
            "Authorization":`Bearer ${vendorKey}`,
            "Content-Type":"application/json",
          },
          body:JSON.stringify(userDetails)
        });
        if(!response.ok){
          console.log("create traveller api ERR : "+response.status+response.statusText);
        }
        else{
        const data= await response.json();
        if(data.message==="success"){
          setUserDataForVisa(data?.result[0]);
          sessionStorage.setItem("userDataForVisa",JSON.stringify(data?.result[0]));
          const selected_information={
            ...userDetails,
            destinationCountry:selectedDestinateCountry,
            passportCountry:selectedPassportCountry,
            travelDate:travelDate
          }
  
          sessionStorage.setItem("visaInfo",JSON.stringify(selected_information));
  
          var search_input={
            destination:selectedDestinateCountry,
            citizenship:selectedPassportCountry,
            arrivalDate:travelDate
        }
        const response2=await fetch(`${base_url}/get_visa_programs_omantel`,{
          method:"POST",
          headers:{
            "Authorization":`Bearer ${vendorKey}`,
            "Content-Type":"application/json"
          },
          body:JSON.stringify(search_input)
        });
        if(!response2.ok){
          console.log("update traveller api ERR : "+response2.status+response2.statusText);
        }
        else{
        const data= await response2.json();
        if(data.message==="success"){
        sessionStorage.setItem("VisaSearchResult",JSON.stringify(data.result.programs[0]));
        sessionStorage.setItem("CountryFlags",JSON.stringify(data.country_flags));
       
         window.location.href="/omantel-visainfo";
         }
         setLoading(false);
        }
        }
        else{

        }
        }
       
    }
  }
  catch(err){
    console.log(err);
  }
      }
      useEffect(() => {
        
        const queryParams = new URLSearchParams(window.location.search);
        const email = queryParams.get('email');
        const first_name=queryParams.get("firstname");
        const last_name=queryParams.get("lastname");
        const locale=queryParams.get("locale");
    
        if(locale){
          debugger
           i18n.changeLanguage(locale);
           
        setlnstr(locale);
        }
        const user ={
          email,
          first_name,
          last_name,
          locale
        }
        if(user?.email&&user?.first_name){
        setUserDetails(user);
        }
       
      }, []);



        // Function to update HTML dir attribute based on language
  const updateHtmlDirAttribute = () => {
    document.documentElement.dir = i18n.dir(); // Set document direction
  };

  // Update HTML dir attribute when component mounts and language changes
  useEffect(() => {
    updateHtmlDirAttribute();
  }, [i18n.language]);

    


      
        useEffect(() => {
      
          const postvData = { organization_name: "Omantel" };
          debugger
      
          if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
      
            debugger
            fetch(base_url + '/create_organization', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(postvData),
            })
              .then(response => response.json())
              .then(data => {
                setVendorkey(data.result[0].vendor_key);
                
              })
              .catch(error => {
                console.error('Error posting data:', error);
              });
      
      
          }
        }, []);
      
      
        useEffect(() => {
          $(selectOpt1.current).select2();

          // document.querySelectorAll(".select2-selection--single").forEach((element) => {
          //   element.style.setProperty("border-radius", "5px", "important");
          //   element.style.setProperty("border", "1px solid #ced4da", "important");
          // });
          // $(selectOpt1.current).next(".select2-container").find(".select2-selection--single").each(function () {
          //   $(this).css("border-radius", "5px");
          //   $(this).css("border", "1px solid #ced4da");
          //   this.style.setProperty("border-radius", "5px", "important");
          //   this.style.setProperty("border", "1px solid #ced4da", "important");
          // });

          $(selectOpt1.current)
          .next(".select2-container")
          .find(".select2-selection--single")
          .each(function() {
              $(this).addClass("omantel");  // Adds the "omantal" class alongside the existing classes
          });
          $(selectOpt1.current)
          .next(".select2-container")
          .find(".select2-dropdown.select2-dropdown--below")
          .each(function() {
              $(this).addClass("select_drawer");  // Adds the "omantal" class alongside the existing classes
          });
          $(selectOpt1.current).on('select2:open', function () {
            setTimeout(() => {
              $('.select2-dropdown').addClass('omantel');
            }, 0); 
          });
        
          $(selectOpt1.current).on('select2:select', (e) => {
            debugger
            // const selectedValue = e.params.data.text;
            const country = e.params.data.id;
            if(country!==null && country!==undefined && country!=="Select" && country!==""){
              $(selectOpt1.current)
              .next(".select2-container")
              .find(".select2-selection--single.omantel")
              .each(function() {
                  $(this).removeClass("error");  // Adds the "omantal" class alongside the existing classes
              });
            }
          //  const selected_result= options.find((opt)=>opt.id===country_id)
            
            checkDestinationCountryStatus(country)
            setSelectedDestinateCountry(country);
            // setAirPortId(selectairport_id);
          });
      
          // Clean up Select2 instance on unmount
          return () => {
            $(selectOpt1.current).select2('destroy');
          };
        }, [vendorKey]);

        const checkDestinationCountryStatus=(country)=>{
          debugger
          if(country!==null&&country!==undefined&&country!==""&&country!=="Select"){
              debugger

              $(selectOpt1.current)
              .next(".select2-container")
              .find(".select2-selection--single.omantel")
              .each(function() {
                  $(this).addClass("success");  // Adds the "omantal" class alongside the existing classes
              });
            }
        }


         const checkPassportCountryStatus=(country)=>{
          debugger
                    if(country!==null&&country!==undefined&&country!==""&&country!=="Select"){
                        debugger
        
                        $(selectOpt2.current)
                        .next(".select2-container")
                        .find(".select2-selection--single.omantel")
                        .each(function() {
                            $(this).addClass("success");  // Adds the "omantal" class alongside the existing classes
                        });
                      }
                  }

                  useEffect(()=>{
                      if(selectedPassportCountry!==null&&selectedPassportCountry!==undefined&&selectedPassportCountry!==""&&selectedPassportCountry!=="Select"){
                        checkPassportCountryStatus(selectedPassportCountry)
                      }
                      if(selectedDestinateCountry!==null&&selectedDestinateCountry!==undefined&&selectedDestinateCountry!==""&&selectedDestinateCountry!=="Select"){
                        checkDestinationCountryStatus(selectedDestinateCountry)
                      }
                  },[selectedPassportCountry,selectedDestinateCountry])

        useEffect(() => {
          $(selectOpt2.current).select2();

          // document.querySelectorAll(".select2-selection--single").forEach((element) => {
          //   element.style.setProperty("border-radius", "5px", "important");
          //   element.style.setProperty("border", "1px solid #ced4da", "important");
          // });
          // $(selectOpt2.current).next(".select2-container").find(".select2-selection--single").each(function () {
          //   $(this).css("border-radius", "5px");
          //   $(this).css("border", "1px solid #ced4da");
          //   this.style.setProperty("border-radius", "5px", "important");
          //   this.style.setProperty("border", "1px solid #ced4da", "important");
          // });

          $(selectOpt2.current)
          .next(".select2-container")
          .find(".select2-selection--single")
          .each(function() {
              $(this).addClass("omantel");  // Adds the "omantal" class alongside the existing classes
          });
          // $(selectOpt2.current)
          // .next(".select2-container")
          // .find(".select2-dropdown.select2-dropdown--below")
          // .each(function() {
          //     $(this).addClass("select_drawer");  // Adds the "omantal" class alongside the existing classes
          // });
          $(selectOpt2.current).on('select2:open', function () {
            setTimeout(() => {
              $('.select2-dropdown').addClass('omantel');
            }, 0); // timeout ensures it happens after DOM is updated
          });
        
          $(selectOpt2.current).on('select2:select', (e) => {
            debugger
            // const selectedValue = e.params.data.text;
            const country = e.params.data.id;
      if(country!==null && country!==undefined && country!=="Select" && country!==""){
                      $(selectOpt2.current)
                      .next(".select2-container")
                      .find(".select2-selection--single.omantel")
                      .each(function() {
                          $(this).removeClass("error");  // Adds the "omantal" class alongside the existing classes
                      });
                    }
                    checkPassportCountryStatus(country);
            setSelectedPassportCountry(country);
            // setAirPortId(selectairport_id);
          });
      
          // Clean up Select2 instance on unmount
          return () => {
            $(selectOpt2.current).select2('destroy');
          };
        }, [vendorKey]);
       useEffect(() => {
      
          if(vendorKey!=='' && options.length===0)
          {
      
            var vkData = {vendor_key: vendorKey};
      
            fetch(base_url+'/country', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(vkData),
            })
                .then(response => response.json())
                .then(data => {
                  // debugger
                  setCountries(data.result);
                })
                .catch(error => {
                  console.error('Error fetching countries:', error);
                });
      
          }
      
        }, [vendorKey]);





        const handleChange=(e)=>{

          setTravelDate(e.target.value);
          setTravelDateErr("");
        }
    
        
const handleHoverBtn=()=>{
   setIsHovered(true);
}
const handleStopBtnHover=()=>{
  setIsHovered(false);
}
useEffect(()=>{
  const getVisaCountryInfo=sessionStorage.getItem("visaInfo");
  if(getVisaCountryInfo){
  const parseInfo = JSON.parse(getVisaCountryInfo);

  setSelectedDestinateCountry(parseInfo.destinationCountry);
  // checkStatus 
   checkDestinationCountryStatus(parseInfo.destinationCountry);

  setSelectedPassportCountry(parseInfo.passportCountry);
  //checkStatus
   checkPassportCountryStatus(parseInfo.passportCountry);
  setTravelDate(parseInfo.travelDate);
  }
  },[])
  useEffect(()=>{
    debugger
 setTimeout( ()=>{ if(selectedPassportCountry!==null&&selectedPassportCountry!==undefined&&selectedPassportCountry!==""&&selectedPassportCountry!=="Select"){
      checkPassportCountryStatus(selectedPassportCountry)
    }
    if(selectedDestinateCountry!==null&&selectedDestinateCountry!==undefined&&selectedDestinateCountry!==""&&selectedDestinateCountry!=="Select"){
      checkDestinationCountryStatus(selectedDestinateCountry)
    }},2000);
},[selectedPassportCountry,selectedDestinateCountry])

    return(
      <>
      <OmantelVisaHeader />
        <div style={{backgroundColor:"#fafafa",fontFamily: 'IBM Plex Sans',height:"100vh"}}>

            <div className='container' >
            <div className='row justify-content-center' > <div className="col-md-8">
            <h1 className='visa_page_heading '>
          {  lnstr==="en"?"Simplifying world travel modernizing your visa":"تبسيط السفر حول العالم وتحديث تأشيرتك" }
            </h1>
            </div></div>
           <div style={{marginTop:"80px"}}>
            <form onSubmit={handleSubmit}>
             <div className='row' style={{display:"flex",alignContent:'center'}}>
                

                           <div className="col-md-4 mb-3  ">
                             <label className='form-label'>{t('Destination')} {t('Country')} <span className='text-danger'>*</span></label>
                             <select
                    ref={selectOpt1}
                    className="form-control omantel"
                    style={{ borderRadius: '5px', height: '30px', width: '100%', maxWidth: '300px' }}
                    // onChange={handlecitizionshipchange} 
                 
                    value={selectedDestinateCountry}
                    
                  >
                   <option value={''} disabled  >{t("Select")}</option>
                    {options.map((country) => (
                      <option key={country.id}  value={country.country}>{t(country.country)}</option>
                    ))}
                  </select>
                           </div>
                           <div className="col-md-4 mb-3">
                             <label className="form-label">{t("Passport")} {t("Country")} <span className='text-danger'>*</span></label>
                             <select
                    ref={selectOpt2}
                    className="form-control omantel"
                    style={{ borderRadius: '5px', height: '30px', width: '100%', maxWidth: '300px' }}
                    // onChange={handlecitizionshipchange} 
                  
                    value={selectedPassportCountry}
                    
                  >
                      <option value={''} disabled>{t("Select")}</option>
                    {options.map((country) => (
                      <option key={country.id}  value={country.country}>{t(country.country)}</option>
                    ))}
                  </select>
                           </div>
                               <div className="col-md-4 mb-3">
                                 <label className="form-label" >{  t("Travel")}{ t("Date")} <span className='text-danger'>*</span></label>
                                 <input
                                   type="date"
                                     className={`form-control omantel ${travelDate!=="" && travelDate!==null && travelDate!==undefined?'success':""} ${travelDateErr==="select travel Date"?"error":""}`}
                                   name="travelDate"
                                   value={travelDate}
                                   onChange={handleChange}
                                   
                                   autoComplete="off"
                                   style={{ borderRadius: '5px',height:"45px" }}
                                   min={new Date(new Date().setDate(new Date().getDate() + 1))
                                     .toISOString()
                                     .split("T")[0]}  // Ensures only tomorrow and future dates
                                   onKeyDown={(e) => e.preventDefault()} 
                                 />
                               </div>
                               </div>
                         <div className="find_visa_btn" style={{marginTop:"50px",display:"flex",justifyContent:"center"}}>
                          
                         <button type="submit" disabled={loading}>
                           {!loading?
                           <span>
                           {  lnstr==="en" ? "Find e-Visa":"البحث عن التأشيرة الإلكترونية"}</span>
                        : <div class="d-flex  justify-content-center"><div class="omantel-loader"></div></div>
                           }
                           </button>
                           
             </div>
             <div >
             {userInfoErr!==""&&<div className='omantel_message_box'>{userInfoErr}</div>}
             </div>
             </form>
             </div>

            </div>
            
           
        </div>
</>
    )
}
export default OmantelVisaPage;